// extracted by mini-css-extract-plugin
export var equalColumn = "_ir-0";